import { CssBaseline, ThemeProvider } from '@mui/material'
import { defaultTheme } from '@repo/unicity/components/ui'
import DefaultRouter from './core/router/Router.tsx'

function App() {
    return (
        <ThemeProvider theme={defaultTheme}>
            <CssBaseline />
            <DefaultRouter />
        </ThemeProvider>
    )
}

export default App
